export type VerifyScrapeCredentialsResult =
  | { ok: true }
  | { ok: false; errorMessage: string }

function basicAuthHeader(username: string, password: string): string {
  return 'Basic ' + btoa(`${username}:${password}`)
}

async function errorMessageFromResponse(response: Response): Promise<string> {
  try {
    const data: unknown = await response.json()
    if (data && typeof data === 'object' && 'message' in data) {
      const msg = (data as { message: unknown }).message
      if (typeof msg === 'string' && msg.length > 0) return msg
    }
  } catch {
    /* ignore */
  }
  if (response.status === 401) {
    return 'ユーザー名またはパスワードが正しくありません'
  }
  return 'ログインに失敗しました'
}

/** Worker の /api/scrape/history で Basic 認証が通るか検証する */
export async function verifyScrapeCredentials(
  workerUrl: string,
  username: string,
  password: string,
  fetchImpl: typeof fetch = fetch
): Promise<VerifyScrapeCredentialsResult> {
  const base = workerUrl.replace(/\/$/, '')
  const url = `${base}/api/scrape/history?limit=1`
  let response: Response
  try {
    response = await fetchImpl(url, {
      headers: { Authorization: basicAuthHeader(username, password) },
    })
  } catch {
    return { ok: false, errorMessage: 'サーバーに接続できませんでした' }
  }

  if (!response.ok) {
    return { ok: false, errorMessage: await errorMessageFromResponse(response) }
  }

  try {
    const data: unknown = await response.json()
    if (data && typeof data === 'object' && (data as { success?: unknown }).success === true) {
      return { ok: true }
    }
    const msg =
      data && typeof data === 'object' && 'message' in data
        ? (data as { message: unknown }).message
        : undefined
    return {
      ok: false,
      errorMessage: typeof msg === 'string' ? msg : 'ログインに失敗しました',
    }
  } catch {
    return { ok: false, errorMessage: '応答の解析に失敗しました' }
  }
}
